import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import { CommonFunctions } from '../common-functions';
import { Admin_Dashboard_Daily_Leave_ApplicationListApiResponse } from '../models/admin-dashboard-daily-leave-application-list-api-response.model';
import { Employee_Dashboard_BasicDetailDtoApiResponse } from '../models/employee-dashboard-basic-detail-dto-api-response.model';
import { Employee_Dashboard_Daily_InOut_DtoApiResponse } from '../models/employee-dashboard-daily-in-out-dto-api-response.model';
import { Employee_Dashboard_Instruction_DetailListApiResponse } from '../models/employee-dashboard-instruction-detail-list-api-response.model';
import { Employee_Dashboard_Monthly_Late_EarlyListApiResponse } from '../models/employee-dashboard-monthly-late-early-list-api-response.model';
import { Employee_Dashboard_Monthly_Missing_ThumbListApiResponse } from '../models/employee-dashboard-monthly-missing-thumb-list-api-response.model';
import { Employee_Dashboard_Monthly_Present_AbsentApiResponse } from '../models/employee-dashboard-monthly-present-absent-api-response.model';
import { Employee_Dashboard_SalayAndDeductionListApiResponse } from '../models/employee-dashboard-salay-and-deduction-list-api-response.model';
import { Employee_NewDashboard_BasicDetailDtoApiResponse } from '../models/employee-new-dashboard-basic-detail-dto-api-response.model';
import { API_BASE_URL } from '../service-proxies';

@Injectable()
export class EmployeeDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private _commonFunctions: CommonFunctions, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEmployeeDashboardBasicDetail(): Observable<Employee_Dashboard_BasicDetailDtoApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetEmployeeDashboardBasicDetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDashboardBasicDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDashboardBasicDetail(<any>response_);
                } catch (e) {
                    return <Observable<Employee_Dashboard_BasicDetailDtoApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_Dashboard_BasicDetailDtoApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeDashboardBasicDetail(response: HttpResponseBase): Observable<Employee_Dashboard_BasicDetailDtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_Dashboard_BasicDetailDtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_Dashboard_BasicDetailDtoApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getEmployeeDailyInOut(): Observable<Employee_Dashboard_Daily_InOut_DtoApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetEmployeeDailyInOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDailyInOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDailyInOut(<any>response_);
                } catch (e) {
                    return <Observable<Employee_Dashboard_Daily_InOut_DtoApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_Dashboard_Daily_InOut_DtoApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeDailyInOut(response: HttpResponseBase): Observable<Employee_Dashboard_Daily_InOut_DtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_Dashboard_Daily_InOut_DtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_Dashboard_Daily_InOut_DtoApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getEmployeeInstructionDetail(): Observable<Employee_Dashboard_Instruction_DetailListApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetEmployeeInstructionDetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeInstructionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeInstructionDetail(<any>response_);
                } catch (e) {
                    return <Observable<Employee_Dashboard_Instruction_DetailListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_Dashboard_Instruction_DetailListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeInstructionDetail(response: HttpResponseBase): Observable<Employee_Dashboard_Instruction_DetailListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_Dashboard_Instruction_DetailListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_Dashboard_Instruction_DetailListApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getEmployeeSalaryandDeduction(): Observable<Employee_Dashboard_SalayAndDeductionListApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetEmployeeSalaryandDeduction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalaryandDeduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalaryandDeduction(<any>response_);
                } catch (e) {
                    return <Observable<Employee_Dashboard_SalayAndDeductionListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_Dashboard_SalayAndDeductionListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeSalaryandDeduction(response: HttpResponseBase): Observable<Employee_Dashboard_SalayAndDeductionListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_Dashboard_SalayAndDeductionListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_Dashboard_SalayAndDeductionListApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getEmployeeMonthlyLateEarly(): Observable<Employee_Dashboard_Monthly_Late_EarlyListApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetEmployeeMonthlyLateEarly";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeMonthlyLateEarly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeMonthlyLateEarly(<any>response_);
                } catch (e) {
                    return <Observable<Employee_Dashboard_Monthly_Late_EarlyListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_Dashboard_Monthly_Late_EarlyListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeMonthlyLateEarly(response: HttpResponseBase): Observable<Employee_Dashboard_Monthly_Late_EarlyListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_Dashboard_Monthly_Late_EarlyListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_Dashboard_Monthly_Late_EarlyListApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getMonthlyPresentAbsent(): Observable<Employee_Dashboard_Monthly_Present_AbsentApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetMonthlyPresentAbsent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyPresentAbsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyPresentAbsent(<any>response_);
                } catch (e) {
                    return <Observable<Employee_Dashboard_Monthly_Present_AbsentApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_Dashboard_Monthly_Present_AbsentApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMonthlyPresentAbsent(response: HttpResponseBase): Observable<Employee_Dashboard_Monthly_Present_AbsentApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_Dashboard_Monthly_Present_AbsentApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_Dashboard_Monthly_Present_AbsentApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getMonthlyMissingThumb(): Observable<Employee_Dashboard_Monthly_Missing_ThumbListApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetMonthlyMissingThumb";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyMissingThumb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyMissingThumb(<any>response_);
                } catch (e) {
                    return <Observable<Employee_Dashboard_Monthly_Missing_ThumbListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_Dashboard_Monthly_Missing_ThumbListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMonthlyMissingThumb(response: HttpResponseBase): Observable<Employee_Dashboard_Monthly_Missing_ThumbListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_Dashboard_Monthly_Missing_ThumbListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_Dashboard_Monthly_Missing_ThumbListApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getTeamLeaveApplication(): Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetTeamLeaveApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamLeaveApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamLeaveApplication(<any>response_);
                } catch (e) {
                    return <Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTeamLeaveApplication(response: HttpResponseBase): Observable<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Admin_Dashboard_Daily_Leave_ApplicationListApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Admin_Dashboard_Daily_Leave_ApplicationListApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getEmployeeNewDashboardDetails(): Observable<Employee_NewDashboard_BasicDetailDtoApiResponse> {
        let url_ = this.baseUrl + "/api/EmployeeDashboard/GetEmployeeNewDashboardDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeNewDashboardDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeNewDashboardDetails(<any>response_);
                } catch (e) {
                    return <Observable<Employee_NewDashboard_BasicDetailDtoApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<Employee_NewDashboard_BasicDetailDtoApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeNewDashboardDetails(response: HttpResponseBase): Observable<Employee_NewDashboard_BasicDetailDtoApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee_NewDashboard_BasicDetailDtoApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return this._commonFunctions.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return this._commonFunctions.throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee_NewDashboard_BasicDetailDtoApiResponse>(<any>null);
    }
}
